import { AnimatedSection } from "@/components/common/AnimatedSection";
import { Star } from "lucide-react";
import { testimonials } from "@/data/testimonials";

export const Testimonials = () => {
  return (
    <section className="bg-surface-subtle section-padding" data-testid="testimonials">
      <div className="container-wide px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12">
            <p className="overline mb-3">Traveler Stories</p>
            <h2 className="heading-lg text-primary">What Our Travelers Say</h2>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {testimonials.map((t, i) => (
            <AnimatedSection key={t.name} delay={i * 0.08}>
              <div
                className="bg-white rounded-xl shadow-card p-6 flex flex-col h-full"
                data-testid={`testimonial-${i + 1}`}
              >
                {/* Stars */}
                <div className="flex items-center gap-0.5 mb-4">
                  {Array.from({ length: t.rating }).map((_, j) => (
                    <Star key={j} className="h-4 w-4 fill-accent text-accent" />
                  ))}
                </div>

                {/* Quote */}
                <p className="text-sm text-foreground/80 leading-relaxed mb-5 flex-1">
                  "{t.text}"
                </p>

                {/* Footer */}
                <div className="flex items-center gap-3 pt-4 border-t border-border/60">
                  <div className="h-10 w-10 rounded-full bg-primary flex items-center justify-center text-primary-foreground text-xs font-bold shrink-0">
                    {t.initials}
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-primary truncate">{t.name}</p>
                    <p className="text-xs text-muted-foreground truncate">{t.location}</p>
                  </div>
                  <p className="ml-auto text-xs text-accent font-medium shrink-0">{t.trip}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};
